import * as S from './style';

interface IProps {
  /** onClick */
  onClick?: () => void;
}

const ModalEdgeCloseBtn = ({ onClick }: IProps) => (
  <S.ModalEdgeCloseBtn
    className="modal-edge-close-btn"
    label="모달 닫기"
    onClick={onClick}
  />
);

export default ModalEdgeCloseBtn;
